var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_BORK/lorem/index.js
// module id = 2129
// module chunks = 2